var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalmarketing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fe366099-a2b1-426e-bf14-5fac3af2633b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd83f169-106c-4888-8974-dd361ca21824",
    x1: 11.95,
    y1: 15,
    x2: 11.95,
    y2: 6.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e9624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5e9724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6cab29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#73b82c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76bc2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2bc33e9-95d3-477a-a9c0-f3c4f4d56e28",
    x1: 6.05,
    y1: 11.51,
    x2: 6.05,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2ba13f3-861a-4e5e-98fb-c7a2c224cdb1",
    x1: 10.51,
    y1: 6.82,
    x2: 7.93,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#035da3",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0b63aa",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#196eb6",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2d7cc6",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#468edb",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-web-48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.18,6.49H9.65A4,4,0,0,0,5.9,10H7.32A2.49,2.49,0,0,1,9.65,8h4.53a2.59,2.59,0,0,1,2.44,2.71,2.6,2.6,0,0,1-2.44,2.72H9.65a2.49,2.49,0,0,1-2.33-2H5.9A4,4,0,0,0,9.65,15h4.53A4.06,4.06,0,0,0,18,10.74,4.06,4.06,0,0,0,14.18,6.49Z",
    fill: "url(#bd83f169-106c-4888-8974-dd361ca21824)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35,10H3.82A2.59,2.59,0,0,1,1.38,7.26,2.6,2.6,0,0,1,3.82,4.54H8.35a2.49,2.49,0,0,1,2.33,2H12.1A4,4,0,0,0,8.35,3H3.82A4.06,4.06,0,0,0,0,7.26a4.06,4.06,0,0,0,3.82,4.25H8.35A4,4,0,0,0,12.1,8H10.68A2.49,2.49,0,0,1,8.35,10Z",
    fill: "url(#a2bc33e9-95d3-477a-a9c0-f3c4f4d56e28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35,10h-3v1.54h3A4,4,0,0,0,12.1,8H10.68A2.49,2.49,0,0,1,8.35,10Z",
    fill: "url(#a2ba13f3-861a-4e5e-98fb-c7a2c224cdb1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalmarketing);
export default __webpack_public_path__ + "static/media/digitalmarketing.b1d611e6f42912cfb34428fa0c69f007.svg";
export { ForwardRef as ReactComponent };